var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#151A30",
    d: "M7.25 16.813h4.071c.374 0 .679-.31.679-.688V12a.685.685 0 00-.679-.688H7.25a.686.686 0 00-.679.688v4.125c0 .378.306.688.679.688zM19.464 3.75H17.43V1.687A.685.685 0 0016.751 1h-1.357a.686.686 0 00-.679.688V3.75H9.286V1.687A.686.686 0 008.607 1H7.25a.686.686 0 00-.679.688V3.75H4.536c-1.124 0-2.036.924-2.036 2.063v15.125C2.5 22.075 3.412 23 4.536 23h14.928c1.124 0 2.036-.924 2.036-2.063V5.813c0-1.138-.912-2.062-2.036-2.062zm0 16.93a.257.257 0 01-.254.258H4.79a.257.257 0 01-.254-.258V7.875h14.928V20.68z"
  }))));
}

export default SvgCalendarDay;